import type { PaymentResponseType, RefusalReasonType } from '../../types';

const RefusalReason: RefusalReasonType = {
  Refused: 'Refused',
  Cancelled: 'Cancelled',
  Error: 'Error',
};
export const paymentRefusalReason = (result: PaymentResponseType['resultCode']): boolean =>
  result ? result === RefusalReason[result] : false;
